import { useQuery } from '@tanstack/react-query';
import { api, DfeLegacyImportEntry } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseImportHistoryReturn {
  imports: DfeLegacyImportEntry[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useImportHistory(): UseImportHistoryReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.inventoryTransition.importHistory(),
    queryFn: () => api.getDfeLegacyImportStatus(),
  });

  return {
    imports: data?.imports ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load import history' : null,
    refresh: () => {
      refetch();
    },
  };
}
